import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Add a new approval matrix entry
export const addApprovalMatrix = async (matrixData) => {
  try {
    const response = await axios.post(`${API_URL}/approval-matrix`, matrixData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get all approval matrix entries
export const getAllApprovalMatrix = async (params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/approval-matrix`, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get single approval matrix entry by ID
export const getApprovalMatrixById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/approval-matrix/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update approval matrix entry
export const updateApprovalMatrix = async (id, matrixData) => {
  try {
    const response = await axios.put(`${API_URL}/approval-matrix/${id}`, matrixData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Delete approval matrix entry
export const deleteApprovalMatrix = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/approval-matrix/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
